import { DropdownButton, Dropdown } from "react-bootstrap";
import "./sortingDropdown.css";

const SortingDropdown: React.FC<{
  selectedValue: string;
  items: { [key: string]: string };
  onSelected: (val: string) => void;
  elementType?: any;
}> = (props) => {
  var opts: any = {};
  if (props.elementType) {
    opts.as = props.elementType;
  }
  return (
    <span className="sorting-container">
      <DropdownButton
        id="category-product-sorting"
        variant="primary"
        title={props.items[props.selectedValue] ?? ""}
        bsPrefix="sorting-btn"
        onSelect={(val) => {
          if (val) {
            props.onSelected(val);
          }
        }}
        {...opts}
      >
        {Object.keys(props.items).map((value) => {
          const text = props.items[value];
          return (
            <Dropdown.Item
              key={value}
              eventKey={value}
              value={value}
              bsPrefix="sorting-item"
              active={value === props.selectedValue}
            >
              {text}
            </Dropdown.Item>
          );
        })}
      </DropdownButton>
    </span>
  );
};

export default SortingDropdown;
